import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function RequireAuth({ children, message }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    if (user === null) {
      if (message) toast.error(message);
      const returnTo = encodeURIComponent(loc.pathname + loc.search);
      nav(`/login?returnTo=${returnTo}`, { replace: true });
    }
  }, [user, nav, loc, message]);

  if (!user) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-gray-400">جاري التحقق...</div>
    );
  }
  return children;
}
